{
  "comment": "M3 streaming (plan R7, spec §4.4, D-TBD 6). Distances in metres. An object spawns when (distance − radius) ≤ spawnRadiusM and despawns when it exceeds despawnRadiusM (hysteresis). perTick caps the stream-ins the session processes per tick. clusters: M1-style dense clusters per field (count range by field kind, centres within placementFraction × the field radius, at least minSeparationM apart when maxTries allows). background: sparse rocks per 20 km cell, scaled by the cell's overlap with the field sphere; power-law radii (pdf ∝ r^−radiusPower); Low drops rocks below lowMinRadiusM (M1's preset rule); homeClearM keeps background rocks off the authored M1 home cluster and its stations. archetypeMix weights are over the M1 archetypes A–F (asteroid-set sheet): A chondrite, B shard, C cratered, D binary, E metal slug, F ice-rich. The ice mix follows the sheet's meanings: F (ice-rich) dominates, A (C-type, volatile-bearing) next, and no E (M-type metal) in an ice field.",
  "cellSizeM": 20000,
  "spawnRadiusM": 100000,
  "despawnRadiusM": 130000,
  "checkEveryTicks": 15,
  "perTick": { "clusters": 1, "cells": 8, "structures": 4 },
  "clusters": {
    "count": { "asteroid": [1, 3], "ice": [1, 2], "gas": [0, 0] },
    "placementFraction": 0.7,
    "minSeparationM": 20000,
    "maxTries": 30,
    "cacheSize": 4
  },
  "background": {
    "rocksPerCell": { "asteroid": 40, "ice": 25, "gas": 0 },
    "radiusM": [20, 300],
    "radiusPower": 2.2,
    "lowMinRadiusM": 15,
    "maxAttempts": 20,
    "homeClearM": 20000
  },
  "archetypeMix": {
    "asteroid": [30, 10, 25, 15, 10, 10],
    "ice": [25, 5, 10, 5, 0, 55]
  },
  "transientDespawnM": 60000
}
